import React, { useCallback, useContext, useEffect, useReducer, useRef, useState } from 'react'
import CSVLoader from './loaders/CSVLoader';
import JsonLoader from './loaders/JsonLoader'
import classnames from 'classnames'
import { OneEuroFilter } from '../util/OneEuroFilter';
import {
    NavItem,
    NavLink,
    Nav,
    TabContent,
    TabPane
} from 'reactstrap'
import { LanguageContext } from '../App';
import Animator from './Animator';

const reducer = (state,action)=>{
    switch(action.type) {
        case "++":
          return state + 1
        case "set":
            return action.value
        case "get":
            return state
        default:
          return state
    }
}

const Visualizer = ()=>{
    const language = useContext(LanguageContext)
    const json_uploader = useRef(null)
    const csv_uploader = useRef(null)
    const [jsonFile,setJsonFile] = useState({})
    const [frameFrequency,setFrameFrequency] = useState(66)
    const [isAnimationActive,setIsAnimationActive] = useState(true)
    const [toggleBtnClass,setToggleBtnClass] = useState("info")
    const [loaderType,setLoaderType] = useState("")
    const [navPills,setNavPills] = useState("csv_loader")
    const [uploaderChangeCounter,setUploaderChangeCounter] = useState(0)
    const [oneEuroConfigs,setOneEuroConfigs] = useState({
        min_cutoff : 0.1,
        beta: 0.005,
        d_cutoff:1.0
    })

    // Toggle navs
    const toggleNavs = (e,pill) =>{
        e.preventDefault()
        setNavPills(pill)
        setLoaderType(pill)

    }

    const handleLoadFile = (uploader) =>{
        setJsonFile(uploader.current.getFileContentJson())
    }


    useEffect(()=>{
        setUploaderChangeCounter((prev)=>prev+1)
    },[json_uploader,csv_uploader])

    const uploaderChangeCounterInc = () =>{
        setUploaderChangeCounter((prev)=>prev+1)
    }


    useEffect(()=>{
        // console.log(oneEuroConfigs)
    },[oneEuroConfigs])

    const applySmoothing = (max_landmarks,frame_frequency) =>{
        // create smoothers
        let new_json_file = {
            frequency: frame_frequency,
            landmarks:[]
        }
        let num_persons = 0
        jsonFile.landmarks.forEach((frame)=>{
            num_persons = (frame.length > num_persons)  ? frame.length : num_persons
        })
        console.log(num_persons)
        let smoothers = []
        for(let j=0;j<num_persons;j++){
            let person_smoothers = []
            let smoother = {}
            for(let i = 0;i<max_landmarks;i++){
                let x_smoother = new OneEuroFilter(
                    frame_frequency,
                    oneEuroConfigs.min_cutoff,
                    oneEuroConfigs.beta,
                    oneEuroConfigs.d_cutoff
                )
                let y_smoother = new OneEuroFilter(
                    frame_frequency,
                    oneEuroConfigs.min_cutoff,
                    oneEuroConfigs.beta,
                    oneEuroConfigs.d_cutoff
                )
                smoother = {x_smoother : x_smoother,y_smoother:y_smoother}
                person_smoothers.push(smoother)
            }
            smoothers.push(person_smoothers)
        }

        // Smoothing
        let timestamp = 0
        jsonFile.landmarks.forEach((frame,f_index)=>{
            frame.forEach((person,p_index)=>{
                timestamp++
                person.forEach((landmark,l_index)=>{
                    let new_landmark_x = smoothers[p_index][l_index].x_smoother.filter(landmark.x,timestamp)
                    let new_landmark_y = smoothers[p_index][l_index].y_smoother.filter(landmark.y,timestamp)
                    jsonFile.landmarks[f_index][p_index][l_index].x = new_landmark_x
                    jsonFile.landmarks[f_index][p_index][l_index].y = new_landmark_y  
                })
            })
        })
        console.log(jsonFile)
        
    }

    return(
        <div>
            
            <div className='container mt-5 pb-5'>
                <Nav
                    className='nav-fill flex-column flex-sm-row'
                    id='tabs-text'
                    pills
                    role='tablist'
                >
                <NavItem>
                        <NavLink
                            aria-selected={navPills === "csv_loader"}
                            className={classnames("mb-sm-3 mb-md-0 btn-danger", {
                            active: navPills === "csv_loader"
                            })}
                            onClick={e => toggleNavs(e, "csv_loader")}
                            href="#pablo"
                            role="tab"
                        >
                            {language.animator.CSVLoader}
                        </NavLink>
                    </NavItem>
                </Nav>
                <div className='mt-5'>
                    {
                        {
                            'csv_loader':  <div>
                                                <CSVLoader accept = {'.csv'} ref={csv_uploader} onSubmitFile={()=>handleLoadFile(csv_uploader)} onLoadFile={uploaderChangeCounterInc} />
                                            </div>,
                            ''          :   <div>
                                                <CSVLoader accept = {'.csv'} ref={csv_uploader} onSubmitFile={()=>handleLoadFile(csv_uploader)} onLoadFile={uploaderChangeCounterInc} />
                                            </div>

                        }[loaderType]
                    }
                </div>
            </div>
            {/*
            <div className='d-flex p-2 justify-content-center'>
                <br />
                <div className='p-3'>
                    <p>min cutoff</p>
                    <input type="number" value={oneEuroConfigs.min_cutoff} min="0" max="1000" step="0.1" onChange={(e)=>{
                        setOneEuroConfigs({...oneEuroConfigs,min_cutoff:e.target.value})
                    }}/>
                </div>
                <div className='p-3'>
                    <p>beta</p>
                    <input type="number" value={oneEuroConfigs.beta} min="0" max="1000" step="0.1" onChange={(e)=>{
                        setOneEuroConfigs({...oneEuroConfigs,beta:e.target.value})
                        
                    }}/>
                </div>
                <div className='p-3'>
                    <p>derivation cutoff</p>
                    <input type="number" value={oneEuroConfigs.d_cutoff} min="0" max="1000" step="0.1" onChange={(e)=>{
                        setOneEuroConfigs({...oneEuroConfigs,d_cutoff:e.target.value})
                    }}/>
                </div>
            </div>
            <button className={'m-2 btn btn-info'} onClick={()=>{applySmoothing(600)}}>Apply Smoothing</button>
                */}
            <Animator 
                jsonFile={jsonFile}
                uploaderChangeCounter={uploaderChangeCounter}
                width={600}
                height={400}

            />
            <br />
            <br />
        </div>
    )
}

export default Visualizer
